import { render, staticRenderFns } from "./V2AddOrderProducts.vue?vue&type=template&id=4f29f66d&scoped=true&"
import script from "./V2AddOrderProducts.vue?vue&type=script&lang=js&"
export * from "./V2AddOrderProducts.vue?vue&type=script&lang=js&"
import style0 from "./V2AddOrderProducts.vue?vue&type=style&index=0&id=4f29f66d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f29f66d",
  null
  
)

export default component.exports